import React, { useEffect } from "react"
import PropTypes from "prop-types"
import WOW from "react-wow"
import { scroller } from "react-scroll"
import { ReactComponent as CompanyIcon } from "../../images/brand.png"

import { WhatsAppWidget } from "react-whatsapp-widget"
import "react-whatsapp-widget/dist/index.css"

import SEO from "./seo"
import GlobalStyles from "src/styles/global"
import * as S from "./styled"
import Navbar from "src/components/sections/Navbar"

const Layout = ({ seo, children, location }) => {
  useEffect(() => {
    if (location.state && location.state.SCROLLTO) {
      setTimeout(
        () =>
          scroller.scrollTo(location.state.SCROLLTO.name, {
            duration: 800,
            smooth: true,
            offset: location.state.SCROLLTO.offset || 0,
          }),
        400
      )
    }
  }, [])

  return (
    <>
      <S.LayoutWrapper>
        <GlobalStyles />
        <SEO {...seo}></SEO>
        <Navbar location={location} />
        <WOW animation="fadeIn">
          <S.LayoutMain>{children}</S.LayoutMain>
        </WOW>
        <div style={{ position: "relative", zIndex: 10000 }}>
          <WhatsAppWidget
            CompanyIcon={CompanyIcon}
            replyTimeText={`Geralmente responde em alguns minutos`}
            message={"Olá! 👋🏼 \n\nComo podemos ajudar você hoje?"}
            phoneNumber="555397083545"
            companyName="Vitor da Evolve Studio"
            sendButtonText={"Enviar"}
            inputPlaceHolder={"Escreva sua mensagem"}
          />
        </div>
      </S.LayoutWrapper>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
